export default __webpack_public_path__ + "../img/85b7c68fe6d170cae6ff352abd2ae1b1.png";